import {Component, OnDestroy, OnInit} from '@angular/core';
import {DataStorageService} from '../../../data-storage.service';
import {AvailableComponents} from '../../../side-bar/enumAvailableComponents';
import {BagElement} from '../../../../models/bagElement';
import {ApiService} from '../../../api.service';
import {ApiOfferService} from '../../../apiServices/offer/api-offer.service';

@Component({
  selector: 'app-offer-summary',
  templateUrl: './offer-summary.component.html',
  styleUrls: ['./offer-summary.component.scss']
})
export class OfferSummaryComponent implements OnInit, OnDestroy {
  agreedConditions: boolean;
  agreedConditionsNDA: boolean;
  btnExportDisabled: boolean;
  exportHasNoVAT: boolean;

  constructor(public dataStorageService: DataStorageService,
              public api: ApiService,
              public oApi: ApiOfferService) {
    this.dataStorageService.currentComponent = 13;
    this.agreedConditions = false;
    this.exportHasNoVAT = false;
    this.btnExportDisabled = false;
    this.agreedConditionsNDA = false;

    this.dataStorageService.currentState.pfMitelHosted.totalUniqueCost = this.dataStorageService.currentState.pfMitelHosted.hosted_unique +
      this.dataStorageService.currentState.pfMitelHosted.cloundLink_unique +
      this.dataStorageService.currentState.pfMitelHosted.vpn_link_unique +
      this.dataStorageService.currentState.pfMitelHosted.mbgTeleworker_unique +
      this.dataStorageService.currentState.pfMitelHosted.oipCTI_unique;

    this.dataStorageService.currentState.pfMitelHosted.totalMonthlyCost =  this.dataStorageService.currentState.pfMitelHosted.hosted_monthly +
      this.dataStorageService.currentState.pfMitelHosted.cloundLink_monthly +
      this.dataStorageService.currentState.pfMitelHosted.vpn_link_monthly +
      this.dataStorageService.currentState.pfMitelHosted.mbgTeleworker_monthly +
      this.dataStorageService.currentState.pfMitelHosted.oipCTI_monthly;
  }

  ngOnInit() {
    this.dataStorageService.currentComponent = AvailableComponents['OfferSummary'];
    const element = document.getElementById('summary');
    element.classList.add('active');
  }

  ngOnDestroy() {
    const element = document.getElementById('summary');
    element.classList.remove('active');
  }

  totalDeviceCost(): number {
    let cost = 0;
    this.dataStorageService.currentState.deviceBag.map(e => cost += (e.device.salePrice * e.quantity));
    return cost;
  }

  totalSolutionsMonthlyCost(): number {
    let cost = 0;
    const flateRateHosted = this.dataStorageService.currentState.businessFlatRateHosted;
    const flateRateSipTrunk = this.dataStorageService.currentState.businessFlatRateSipTrunk;
    const threeCX = this.dataStorageService.currentState.threeCX;
    const bundle = this.dataStorageService.currentState.peoplefoneBundle;
    if (this.dataStorageService.currentState.wishedSolution.PeoplephoneInternetIPworldcom) {
      this.dataStorageService.currentState.PPinternetIPworldcom.internet.map(e => cost += e.totalMonthlyCost);
    }
    if (this.dataStorageService.currentState.wishedSolution.PeoplephoneInternetCyberlink) {
      this.dataStorageService.currentState.PPinternetCyberlink.internet.map(e => cost += e.totalMonthlyCost);
    }
    if (this.dataStorageService.currentState.wishedSolution.PhoneNumbersToBePorted) {
      this.dataStorageService.currentState.phoneNumbersToBePorted.range.forEach(range => {
        if (range.costMonthlyEdit) {
          cost += range.costMonthly;
        } else {
          cost += range.costMonthly;
        }
      });
    }
    if (this.dataStorageService.currentState.wishedSolution.NewPhoneNumbers) {
      this.dataStorageService.currentState.newPhoneNumber.range.forEach(range => {
        if (range.costMonthlyEdit) {
          cost += range.costMonthly;
        } else {
          cost += range.costMonthly;
        }
      });
    }
    if (this.dataStorageService.currentState.wishedSolution.PeoplephoneHosted) {
      cost += this.dataStorageService.currentState.PPhosted.usersMonthlyCost +
        this.dataStorageService.currentState.PPhosted.softphoneMonthlyCost +
        this.dataStorageService.currentState.PPhosted.connectorApiMonthlyCost +
        this.dataStorageService.currentState.PPhosted.connectorStandardMonthlyCost
        + this.nodesCost();
    }
    if (this.dataStorageService.currentState.wishedSolution.FlatRateHOSTED) {
      const pricingElement = this.dataStorageService.flatRateHostedPricing.filter(e => e.networkType === flateRateHosted.chosenType)[0];
      if (pricingElement === undefined) {
        cost += (flateRateHosted.unitMonthlyCost * flateRateHosted.numberOfFlatRates);
      } else {
        cost += (pricingElement.unitMonthlyCost * flateRateHosted.numberOfFlatRates);
      }
    }
    if (this.dataStorageService.currentState.wishedSolution.FlatRateSIPTRUNK) {
      const pricingElement = this.dataStorageService.flatRateSipTrunkPricing
        .filter(e => e.networkType === flateRateSipTrunk.chosenType)[0];
      if (pricingElement === undefined) {
        cost += (flateRateSipTrunk.unitMonthlyCost * flateRateSipTrunk.numberOfFlatRates);
      } else {
        cost += (pricingElement.unitMonthlyCost * flateRateSipTrunk.numberOfFlatRates);
      }
    }
    if (this.dataStorageService.currentState.wishedSolution.ThreeCX) {
      // cost += this.dataStorageService.currentState.threeCX.costMonthlyAddon + this.dataStorageService.currentState.threeCX.costMonthlySub;
      // Get monthly Subscription Costs
      let pricingElement = this.dataStorageService.threeCXPricing
        .find(e => e.type === threeCX.type && e.term === threeCX.term && e.sc === threeCX.sc);
      if (pricingElement === undefined) {
        cost += (threeCX.costMonthlySub);
      } else {
        cost += (pricingElement.costMonthly);
      }
      // Get monthly Addon Costs
      pricingElement = this.dataStorageService.threeCXPricing
        .find(e => e.type === threeCX.addon && e.term === -1 && e.sc === -1);
      if (pricingElement === undefined) {
        cost += (threeCX.costMonthlyAddon);
      } else {
        cost += (pricingElement.costMonthly);
      }
    }
    if (this.dataStorageService.currentState.wishedSolution.MicrosoftTeams) {
      const pricingElement = this.dataStorageService.teamsPricing[0];
      if (pricingElement === undefined) {
        cost += (this.dataStorageService.currentState.microsoftTeams.costMonthly);
      } else {
        cost += (pricingElement.costMonthly * this.dataStorageService.currentState.microsoftTeams.users);
      }
    }
    if (this.dataStorageService.currentState.wishedSolution.OperatorConnect) {
        cost += this.dataStorageService.currentState.operatorConnect.costMonthly;
    }
    if (this.dataStorageService.currentState.wishedSolution.SBCplus) {
      cost += this.dataStorageService.currentState.sbcplus.costMonthly;
    }
    if (this.dataStorageService.currentState.wishedSolution.PeoplefoneBundle) {
      const pricingElementBundle = this.dataStorageService.bundlePricing
        .find(e => e.type === bundle.type && e.spec === bundle.spec);
      const pricingElementAddon = this.dataStorageService.bundlePricing
        .find(e => e.type === 'Porting' && e.spec === bundle.numbersPorting);
      if (pricingElementBundle === undefined || pricingElementAddon === undefined) {
        cost += this.dataStorageService.currentState.peoplefoneBundle.costMonthly;
      } else {
        cost += pricingElementBundle.costMonthly;
        cost += pricingElementAddon.costMonthly;
      }
    }
    if (this.dataStorageService.currentState.wishedSolution.PeoplefoneMittel) {
      cost += this.dataStorageService.currentState.pfMitelHosted.totalMonthlyCost;
    }

    if(this.dataStorageService.currentState.wishedSolution.Datasim) {
      cost += this.totalCostDatasimMonthly();
    }

    if(this.dataStorageService.currentState.wishedSolution.mobile) {
      cost += this.totalCostMobileMonthly();
    }

    return cost;
  }

  totalSolutionsUniqueCost(): number {
    let cost = 0;
    if (this.dataStorageService.currentState.wishedSolution.PeoplephoneInternetIPworldcom) {
      this.dataStorageService.currentState.PPinternetIPworldcom.internet.map(e => cost += e.totalUniqueCost);
    }
    if (this.dataStorageService.currentState.wishedSolution.PeoplephoneInternetCyberlink) {
      this.dataStorageService.currentState.PPinternetCyberlink.internet.map(e => cost += e.totalUniqueCost);
    }
    if (this.dataStorageService.currentState.wishedSolution.PhoneNumbersToBePorted) {
      this.dataStorageService.currentState.phoneNumbersToBePorted.range.map(e => cost += e.costUnique);
    }
    if (this.dataStorageService.currentState.wishedSolution.NewPhoneNumbers) {
      this.dataStorageService.currentState.newPhoneNumber.range.map(e => cost += e.costUnique);
    }
    if (this.dataStorageService.currentState.wishedSolution.MicrosoftTeams) {
      cost += this.dataStorageService.currentState.microsoftTeams.costUnique;
    }
    if (this.dataStorageService.currentState.wishedSolution.OperatorConnect) {
      cost += this.dataStorageService.currentState.operatorConnect.costUnique;
    }
    if (this.dataStorageService.currentState.wishedSolution.SBCplus) {
      cost += this.dataStorageService.currentState.sbcplus.costUnique;
    }
    if (this.dataStorageService.currentState.wishedSolution.PeoplefoneBundle) {
      cost += this.dataStorageService.currentState.peoplefoneBundle.costUnique;
      cost += this.dataStorageService.currentState.peoplefoneBundle.routerCostUnique;
      console.log(cost + ' ' + this.dataStorageService.currentState.peoplefoneBundle.routerCostUnique);
    }
    if (this.dataStorageService.currentState.wishedSolution.PeoplephoneHosted) {
      cost += this.dataStorageService.currentState.PPhosted.connectorStandardUniqueCost;
    }
    if (this.dataStorageService.currentState.wishedSolution.PeoplefoneMittel) {
      cost += this.dataStorageService.currentState.pfMitelHosted.totalUniqueCost;
    }

    if(this.dataStorageService.currentState.wishedSolution.Datasim) {
      cost += this.totalCostDatasimUnique();
    }

    if(this.dataStorageService.currentState.wishedSolution.mobile) {
      cost += this.totalCostMobileUnique();
    }

    return cost;
  }

  discountPrice() {
    if (this.dataStorageService.currentState.discount > 0) {
      var total = this.totalDeviceCost()
      const discountPrice = this.totalDeviceCost() - Math.round(total /(1+this.dataStorageService.currentState.discount * 0.01));
      return discountPrice;
    } else {
      return 0;
    }
  }

  costWithDiscount() {
    if (this.dataStorageService.currentState.discount > 0) {
      var total = this.totalDeviceCost()
      const discountPrice = Math.round(total /(1+this.dataStorageService.currentState.discount * 0.01));
      return discountPrice;
    } else {
      return this.totalDeviceCost();
    }
  }

  setDiscountValue(event: any) {
    this.dataStorageService.currentState.discount = event.target.value;
    this.oApi.putOfferOptions();
  }

  totalMicrosoftTeamsProductsMonthly(): number {
    let cost = 0;
    if(this.dataStorageService.currentState.wishedSolution.MicrosoftTeams){
      cost +=  this.dataStorageService.currentState.microsoftTeams.costMonthly
    }
    if(this.dataStorageService.currentState.wishedSolution.OperatorConnect) {
      cost += this.dataStorageService.currentState.operatorConnect.costMonthly
    }

    if(this.dataStorageService.currentState.wishedSolution.SBCplus) {
      cost += this.dataStorageService.currentState.sbcplus.costMonthly
    }

    return cost
  }

  totalMicrosoftTeamsProductsUnique(): number {
    let cost = 0;
    if(this.dataStorageService.currentState.wishedSolution.MicrosoftTeams){
      cost += this.dataStorageService.currentState.microsoftTeams.costUnique
    }
    if(this.dataStorageService.currentState.wishedSolution.OperatorConnect) {
      cost += this.dataStorageService.currentState.operatorConnect.costUnique
    }

    if(this.dataStorageService.currentState.wishedSolution.SBCplus) {
      cost += this.dataStorageService.currentState.sbcplus.costUnique
    }

    return cost
  }

  totalCostNewPhoneNumbersMonthly(): number {
    let cost = 0;
    this.dataStorageService.currentState.newPhoneNumber.range.forEach(range => {
      if (range.costMonthlyEdit) {
        cost += range.costMonthly;
      } else {
        cost += range.costMonthly;
      }
    });
    return cost;
  }

  totalCostDatasimMonthly(): number {
    let cost = 0;
    this.dataStorageService.currentState.datasims.map(e => cost += e.costMonthly);
    return cost;
  }

  totalCostDatasimUnique(): number {
    let cost = 0;
    this.dataStorageService.currentState.datasims.map(e => cost += e.costUnique);
    return cost;
  }

  totalCostMobileMonthly(): number {
    let cost = 0;
    this.dataStorageService.currentState.mobiles.map(e => cost += (e.subscriptionMonthly + e.extraCardDataMonthly + e.extraCardWatchMonthly) * e.quantity);
    return cost;
  }

  totalCostMobileUnique(): number {
    let cost = 0;
    this.dataStorageService.currentState.mobiles.map(e => cost += (e.subscriptionUnique + e.extraCardDataUnique + e.extraCardWatchUnique) * e.quantity);
    return cost;
  }

  totalCostNewPhoneNumbersUnique(): number {
    let cost = 0;
    this.dataStorageService.currentState.newPhoneNumber.range.map(e => cost += e.costUnique);
    return cost;
  }

  setPoDnewPhoneNumberMonthlyCost(event: any, index: number) {
    this.dataStorageService.currentState.newPhoneNumber.range[index].costMonthly = Math.floor(parseFloat(event.target.value) * 100);
    this.api.putNewNumbers(this.dataStorageService.currentState.offerID);
  }

  setPoDnew3CXSubscriptionCostMonthly(event: any) {
    this.dataStorageService.currentState.threeCX.costMonthlySub = Math.floor(parseFloat(event.target.value) * 100);
    this.api.putThreeCX(this.dataStorageService.currentState.offerID);
  }

  totalCostPortedNumbersMonthly(): number {
    let cost = 0;
    this.dataStorageService.currentState.phoneNumbersToBePorted.range.forEach(range => {
      if (range.costMonthlyEdit) {
        cost += range.costMonthly;
      } else {
        cost += range.costMonthly;
      }
    });
    return cost;
  }

  totalCostPortedNumbersUnique(): number {
    let cost = 0;
    this.dataStorageService.currentState.phoneNumbersToBePorted.range.map(e => cost += e.costUnique);
    return cost;
  }

  setPoDportedMonthlyCost(event: any, index: number) {
    this.dataStorageService.currentState.phoneNumbersToBePorted.range[index].costMonthly = Math.floor(parseFloat(event.target.value) * 100);
    this.api.putPortedNumbers(this.dataStorageService.currentState.offerID);
  }

  setPoDportedUniqueCost(event: any, index: number) {
    this.dataStorageService.currentState.phoneNumbersToBePorted.range[index].costUnique = Math.floor(parseFloat(event.target.value) * 100);
    this.api.putPortedNumbers(this.dataStorageService.currentState.offerID);
  }

  printOffer() {
    this.api.getPrintOffer(this.dataStorageService.currentState.offerID, this.exportHasNoVAT);
  }

  costSummaryMonthlyVAT() {
    //return value - Math.round(((float) value)/(1.0f + ((float) tenThousandth) / 10000.0f));
    //var value = this.totalSolutionsMonthlyCost() / 1.0 +
    var total = this.totalSolutionsMonthlyCost()

    const cost = (total - (total / (this.dataStorageService.vatValue + 1))) / 100;

    return Number(cost.toFixed(2));
  }

  costSummaryUniqueVAT() {
    //{{ ((costWithDiscount() + totalSolutionsUniqueCost()) * dataStorageService.vatValue) / 100 | PeopleFoneCurrencyFormat}}
    var total = (this.costWithDiscount() + this.totalSolutionsUniqueCost()) * 100
    const cost = (total - (total / (this.dataStorageService.vatValue + 1))) / 10000;

    return Number(cost.toFixed(2));
  }

  nodesCost(): number {
    let cost = 0;
    this.dataStorageService.nodesPricingPPhosted.forEach(elem => {
      if (this.dataStorageService.currentState.PPhosted.nodes >= elem.countFrom &&
        this.dataStorageService.currentState.PPhosted.nodes <= elem.countTo) {
        cost = elem.costMonthly;
      }
    });
    return cost;
  }

  getSalePrice(myBagElement: BagElement): number {
    return myBagElement.device.salePrice * myBagElement.quantity;
  }

  highlightConditions() {
    if(!this.agreedConditions) {
      const element = document.getElementById('agreedConditionsText');
      element.setAttribute('class', 'conditions highlightConditions');
    }

    if(!this.agreedConditionsNDA) {
      const element = document.getElementById('agreedConditionsTextNDA');
      element.setAttribute('class', 'conditions highlightConditions');
    }

    this.btnExportDisabled = true;
  }

  agreeConditions() {
    this.btnExportDisabled = false;
    this.agreedConditions = true;

    const element = document.getElementById('agreedConditionsText');
    element.setAttribute('class', 'conditions');
  }

  agreeConditionsNDA() {
    this.btnExportDisabled = false;
    this.agreedConditionsNDA = true;

    const element = document.getElementById('agreedConditionsTextNDA');
    element.setAttribute('class', 'conditions');
  }

  exportHasNoVATToggle(){
    this.exportHasNoVAT = !this.exportHasNoVAT;
  }

  disagreeConditions() {
    this.agreedConditions = false;
  }

  disagreeConditionsNDA() {
    this.agreedConditionsNDA = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/content/new-offer/offer-summary/offer-summary.component.ts